export const HISTORY = [
  {
    year: 2025,
    events: [
      {
        date: '01',
        text: [
          'R&C Entertainment Actor LABEL 설립',
          '배우 윤시윤 전속계약 체결',
          '㈜하이브리드(뮤직 프로듀싱 레이블)와 계약 체결 → KMG 레이블로 편입',
        ],
      },
      {
        date: '03',
        text: '싱가폴 KMG GLOBAL ENTERTAINMENT 설립',
      },
    ],
  },
  {
    year: 2024,
    events: [
      {
        date: '01',
        text: '정혜선, 안재모, 이수경, 김비비, 이상보 전속계약 체결',
      },
      {
        date: '02',
        text: '이황의, 장남수, 길하은 전속계약 체결',
      },
    ],
  },
  {
    year: 2023,
    events: [
      {
        date: '04',
        text: '가수 준재(JUNJE) 데뷔',
      },
      {
        date: '12',
        text: [ '(주)코리아매니지먼트 사명 변경', '배우 매니지먼트 신설' ],
      },
    ],
  },
  {
    year: 2021,
    events: [
      {
        date: '01',
        text: 'DJ레이블 핸드메이드 설립',
      },
    ],
  },
  {
    year: 2019,
    events: [
      {
        date: '02',
        text: [ '일본 JAKAL Corporation과 협업', '하민우 일본 활동, 일본 콘서트 개최' ],
      },
    ],
  },
  {
    year: 2018,
    events: [
      {
        date: '04',
        text: '가수 하민우(ZE:A) 전속계약 체결',
      },
    ],
  },
  {
    year: 2017,
    events: [
      {
        date: '02',
        text: '가수 장정한 데뷔',
      },
      {
        date: '06',
        text: '가수 김보경 전속계약 체결',
      },
    ],
  },
  {
    year: 2016,
    events: [
      {
        date: '04',
        text: '가수 주석 전속계약 체결',
      },
      {
        date: '06',
        text: 'DJ Schedule 1 업무협약 체결',
      },
    ],
  },
  {
    year: 2015,
    events: [
      {
        date: '01',
        text: '가수 문샤인 솔로 데뷔',
      },
      {
        date: '09',
        text: '(주)코리아뮤직그룹으로 사명 변경',
      },
      {
        date: '12',
        text: '신인가수 태오(tae5) 데뷔',
      },
    ],
  },
  {
    year: 2014,
    events: [
      {
        date: '07',
        text: '(주)영앤문컴퍼니 법인 설립',
      },
      {
        date: '08',
        text: '가수 메이드인(MADEIN) 데뷔',
      },
    ],
  },
]
